export default "__VITE_ASSET__DlGDkMVh__"